import checkbox from '@form-create/component-ivu-checkbox/src/index';
import frame from '@form-create/component-ivu-frame/src/index';
import radio from '@form-create/component-ivu-radio/src/index';
import select from '@form-create/component-ivu-select/src/index';
import tree from '@form-create/component-ivu-tree/src/index';
import upload from '@form-create/component-ivu-upload/src/index';
import group from '@form-create/component-ivu-group/src/index';
import subForm from '@form-create/component-subform/src/index';

export default [
    checkbox,
    radio,
    select,
    tree,
    subForm,
    frame,
    upload,
    group
];
